module.exports = __webpack_public_path__ + "img/labs3.a4e3e822.svg";